<ion-content fullscreen>
  <div id="wrapper" class="ion-padding">
    <div id="id">
      <ion-fab-button color="light" size="small" (click)="goNotifications()">
        <ion-icon src="/assets/icon/notifications-new.svg"></ion-icon>
      </ion-fab-button>
      <ion-fab-button color="light" size="small" (click)="goId()">
        <ion-icon src="/assets/icon/id.svg" class="icon_id"></ion-icon>
      </ion-fab-button>
    </div>
    <ion-icon src="/assets/icon/tecservice.svg" class="header-logo" (click)="navigateToProfile()"></ion-icon>

    <ion-item>
      <ion-avatar slot="start" (click)="goId()">
        <img [src]="user.avatar" *ngIf="user && user.avatar" />
        <img src="/assets/imgs/logo-blanco.png" *ngIf="!user || !user.avatar" />
      </ion-avatar>
      <ion-label>
        {{ user?.name }} {{user?.lastname}}
        <span>{{user?.enrollment}}</span>
      </ion-label>
    </ion-item>
    <swiper-container #swiper [pagination]="true" *ngIf="ads" id="ads">
      <swiper-slide *ngFor="let ad of ads; let i = index;">
        <ion-img [src]="ad.image" (click)="viewImage(ad.image, '', '')"></ion-img>
      </swiper-slide>
    </swiper-container>

    <swiper-container #swiperCategories [pagination]="true" id="categories" [class.fadeOut]="!categories">
      <ng-template ngFor let-category [ngForOf]="categories" let-i="index" let-last="last">
        <swiper-slide *ngIf="i % 4 == 0">
          <div id="cat_wrapper">
            <ion-button
              expand="block"
              class="square_button"
              color="light"
              (click)="category.is_parent ? goCategory(category) : goBusinesses(category)"
            >
              <div class="vertical">
                <img slot="start" [src]="category.icon" />
                <span>{{category.name}}</span>
              </div>
            </ion-button>
            <ion-button
              *ngIf="i + 1 < categories.length"
              expand="block"
              class="square_button"
              color="light"
              (click)="categories[i+1].is_parent ? goCategory(categories[i+1]) : goBusinesses(categories[i+1])"
            >
              <div class="vertical">
                <img slot="start" [src]="categories[i+1].icon" />
                <span>{{categories[i+1].name}}</span>
              </div>
            </ion-button>
            <ion-button
              *ngIf="i + 2 < categories.length"
              expand="block"
              class="square_button"
              color="light"
              (click)="categories[i+2].is_parent ? goCategory(categories[i+2]) : goBusinesses(categories[i+2])"
            >
              <div class="vertical">
                <img slot="start" [src]="categories[i+2].icon" />
                <span>{{categories[i+2].name}}</span>
              </div>
            </ion-button>
            <ion-button
              *ngIf="i + 3 < categories.length"
              expand="block"
              class="square_button"
              color="light"
              (click)="categories[i+3].is_parent ? goCategory(categories[i+3]) : goBusinesses(categories[i+3])"
            >
              <div class="vertical">
                <img slot="start" [src]="categories[i+3].icon" />
                <span>{{categories[i+3].name}}</span>
              </div>
            </ion-button>
            <ion-button
              expand="block"
              class="square_button"
              color="light"
              (click)="goLocatec()"
              *ngIf="user && user.campus_current === 2 && i === categories.length - 1 && categories.length % 2 != 0"
            >
              <div class="vertical">
                <img slot="start" src="/assets/icon/location-pin.svg" class="locatec" />
                <span>LOCATEC</span>
              </div>
            </ion-button>
          </div>
        </swiper-slide>
        <swiper-slide
          *ngIf="user && user.campus_current === 2 && i === categories.length - 1 && categories.length % 2 === 0"
        >
          <div id="cat_wrapper">
            <ion-button expand="block" class="square_button" color="light" (click)="goLocatec()">
              <div class="vertical">
                <img slot="start" src="/assets/icon/location-pin.svg" class="locatec" />
                <span>LOCATEC</span>
              </div>
            </ion-button>
          </div>
        </swiper-slide>
      </ng-template>
    </swiper-container>
  </div>
</ion-content>
